import * as React from "react";
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { isNullOrUndefined } from "components/utils";
import { Grid, Input } from "components/controls/widget";

interface SearchInputProps {
    onChanged: (value: string) => void;
}

class SearchInput extends React.Component<SearchInputProps> {

    private valueChanged$: Subject<string> = new Subject();
    private valueChangedSubscr: Subscription;

    onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const val: string = isNullOrUndefined(event.target.value) ? "" : event.target.value.trim();
        this.valueChanged$.next(val);
    }

    componentDidMount() {
        this.valueChangedSubscr = this.valueChanged$
            .pipe(debounceTime(300))
            .subscribe(this.props.onChanged);
    }

    componentWillUnmount() {

        if (this.valueChangedSubscr !== undefined) {
            this.valueChangedSubscr.unsubscribe();
            this.valueChangedSubscr = undefined;
        }

    }

    render() {
        return <Grid container wrap="nowrap" direction="row" alignItems="center" spacing={16} >
            <Grid item sm={1}>
                {'Hledat: '}
            </Grid>
            <Grid item sm={11}>
                <Input onChange={this.onChange} autoFocus fullWidth />
            </Grid>
        </Grid>
    }
}

export default SearchInput;